import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getContractDocumentListData } from './mockData'
import type { IContractDocument } from '~/types/document/models'

export const {
  getDocuments: getContractDocuments,
  postDocument: postContractDocument,
  patchDocument: patchContractDocument,
  deleteDocument: deleteContractDocument,
  handlers,
} = makeDocumentAPIs<IContractDocument>({
  apiPathEntityNamePrefix: 'contract',
  getDocumentListDataFn: getContractDocumentListData,
})
